import React, { useState, useEffect } from 'react';
import { User, Bot, Check, Loader2 } from 'lucide-react';

// no se si el sdk es lo que necesito
//import { init } from '@telegram-apps/sdk';


import { personalities } from './constants';

import { Personality} from '@/modules/telegram-app/components/personality';
import { Header } from '@/modules/telegram-app/components/header';

const TelegramMiniApp = () => {
  const [user, setUser] = useState(null);
  const [selectedPersonality, setSelectedPersonality] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);


  useEffect(() => {
    initTelegramApp();
  }, []);

  const initTelegramApp = async () => {
    try {
      // no funciono
      // // https://docs.telegram-mini-apps.com/packages/telegram-apps-sdk/3-x/initializing
      // init(); // usando el sdk

      const tg = window.Telegram?.WebApp;
      
      if (tg) {
        tg.ready();
        tg.expand();

        
        const telegramUser = tg.initDataUnsafe?.user;
        
        if (telegramUser) {
          setUser({
            id: telegramUser.id,
            firstName: telegramUser.first_name,
            lastName: telegramUser.last_name,
            username: telegramUser.username
          });

          await loadUserPersonality(telegramUser.id);
        } else {
          setUser({
            id: 'demo',
            firstName: 'Usuario',
            lastName: 'Demo'
          });
        }
      } else {
        setUser({
          id: 'demo',
          firstName: 'Usuario',
          lastName: 'Demo'
        });
      }
    } catch (error) {
      console.error('Error inicializando Telegram:', error);
      setUser({
        id: 'demo',
        firstName: 'Usuario',
        lastName: 'Demo'
      });
    } finally {
      setLoading(false);
    }
  };

  const loadUserPersonality = async (userId) => {
    try {
      // Usar localStorage para persistencia
      const saved = localStorage.getItem(`user_personality:${userId}`);
      if (saved) {
        const data = JSON.parse(saved);
        setSelectedPersonality(data.personalityId);
      }
    } catch (error) {
      console.log('No hay personalidad guardada previamente');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-linear-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <Loader2 className="w-12 h-12 text-blue-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-linear-to-br from-blue-50 to-indigo-100 p-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <Header user={user}/>

        {/* Personalidades */}
        <div className="space-y-3">
          {personalities.map((personality) => (
            <Personality
              key={personality.id}
              personality = { personality }
              personalities = { personalities }
              selectedPersonality = {selectedPersonality}
              setSelectedPersonality = {setSelectedPersonality}
              setSaving = {setSaving}
              user = {user}
            />
          ))}
        </div>

        {/* Footer */}
        {saving && (
          <div className="mt-6 bg-blue-100 rounded-xl p-4 flex items-center justify-center gap-3">
            <Loader2 className="w-5 h-5 text-blue-600 animate-spin" />
            <span className="text-blue-700 font-medium">Guardando...</span>
          </div>
        )}

        {selectedPersonality && !saving && (
          <div className="mt-6 bg-green-100 rounded-xl p-4 text-center">
            <p className="text-green-700 font-medium">
              ✅ Personalidad seleccionada: {personalities.find(p => p.id === selectedPersonality)?.name}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TelegramMiniApp;